<template>
  <div>
    <div class="modal-overlay" id="modal-overlay"></div>
    <div class="modal" id="modal">

      <img alt="" class="alert" src="../assets/icons_attention.svg"/>

      <h2>
        {{ question.perspective === 'car'
          ? question.car.question
          : question.bike.question
        }}
      </h2>

      <div
          :is="question[question.perspective].type"
          :question="question"
          ref="questionForm"
      ></div>

      <div class="modal-controls">
        <button
            class="default"
            @click.prevent.stop="$emit('question-rewind')"
        >
          <img class="leftIcon" src="../assets/icons_UI_icon_again.svg" alt="" />
          <span>Abschnitt erneut ansehen</span>
        </button>
        <button
            class="green glow"
            @click.prevent.stop="submitQuestion"
        >
          <span>Weiter</span>
          <img
              class="rightIcon hoverNo"
              src="../assets/icons_UI_chevron_right_black.svg"
              alt="" />
          <img
              class="rightIcon hoverYes"
              src="../assets/icons_UI_chevron_right.svg"
              alt="" />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import MultipleChoice from "./QuestionModal/MultipleChoice";
import Slider from "./QuestionModal/Slider";

export default {
  name: "QuestionModal",
  props: {
    question: Object,
  },
  components: {MultipleChoice, Slider},
  data() {
    return {
      answerOptions: []
    }
  },
  methods: {
    submitQuestion() {
      this.$emit(
          'question-submit',
          this.$refs.questionForm.validateAnswer()
      );
    }
  }
}
</script>

<style lang="scss" scoped>

$vhUnit: 9;
$vwUnit: 16;
$vhUnitMobile: 3.75;
$vwUnitMobile: 6.66;

@function scaleVh($size) {
  @return #{($size/$vhUnit)}vh;
}
@function scaleVw($size) {
  @return #{($size/$vwUnit)}vw;
}
@function scaleMobileVh($size) {
  @return #{($size/$vhUnitMobile)}vh;
}
@function scaleMobileVw($size) {
  @return #{($size/$vwUnitMobile)}vw;
}

h2,
.alert {
  display: block;
  margin-left: auto;
  margin-right: auto;
}

.mobile img.alert {
  display: none;
}

.mobile {
  h2 {
    width: auto;
  }
}

@media(min-aspect-ratio: 16/9) {

  h2 {
    width: scaleVh(1000);
  }

  .alert {
    margin-top: scaleVh(175);
    width:scaleVh(70);
    height: scaleVh(80);
  }
}

@media(max-aspect-ratio: 16/9) {

  h2 {
    width: scaleVw(1000);
  }

  .alert {
    margin-top: scaleVw(175);
    width:scaleVw(70);
    height: scaleVw(80);
  }
}


</style>